import { BaseViewModel } from "@iot-platform/core";
import type { SensorAlertUpdate } from "@station/domain/models/sensor-alert.model.ts";
import { SensorAlerts } from "@station/domain/models/sensor-alert.model.ts";
import { SensorAlertGetAllUseCase } from "@station/domain/usecases/sensor-alert-get-all.usecase.ts";
import { SensorAlertUpdateUseCase } from "@station/domain/usecases/sensor-alert-update.usecase.ts";
import { inject, injectable } from "inversify";
import { action, makeObservable, observable, runInAction } from "mobx";

@injectable()
export class SensorAlertViewmodel extends BaseViewModel {
    @observable
    sensorAlerts: SensorAlerts = SensorAlerts.empty();

    @observable
    initialLoading = false;

    @observable
    private stationId?: string;

    constructor(
        @inject(SensorAlertUpdateUseCase)
        private readonly sensorAlertUpdateUseCase: SensorAlertUpdateUseCase,
        @inject(SensorAlertGetAllUseCase)
        private readonly sensorAlertGetAllUseCase: SensorAlertGetAllUseCase,
    ) {
        super();
        makeObservable(this);
    }

    override async didMount(): Promise<void> {
        await this.initViewData();
    }

    private async initViewData(): Promise<void> {
        await this.getAllSensorAlert();

        runInAction(() => {
            this.initialLoading = false;
        });
    }

    @action
    async updateSensorAlert(
        sensorAlertUpdate: SensorAlertUpdate,
    ): Promise<void> {
        await this.sensorAlertUpdateUseCase.execute(sensorAlertUpdate);
        await this.getAllSensorAlert();
    }

    @action
    async getAllSensorAlert(): Promise<void> {
        if (this.stationId) {
            const sensorAlertsFetched =
                await this.sensorAlertGetAllUseCase.execute(this.stationId);

            runInAction(() => {
                this.sensorAlerts = sensorAlertsFetched;
            });
        }
    }

    setStationId(stationId: string): void {
        runInAction(() => {
            this.stationId = stationId;
        });
    }
}
